import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '../../services/services';
import { ConfigService } from '../../services/config.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.css']
})
export class NavMenuComponent {

    public CurrentTenantId: string;

    constructor(
        public auth: AuthService,
        public config: ConfigService,
        private router: Router) {
            
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/src/app/components/navmenu/navmenu.component.ts